export default "__VITE_ASSET__9ZHBREPP__"